import { render, staticRenderFns } from "./YtVideoWithConsent.vue?vue&type=template&id=15dec52c&scoped=true&"
import script from "./YtVideoWithConsent.vue?vue&type=script&lang=js&"
export * from "./YtVideoWithConsent.vue?vue&type=script&lang=js&"
import style0 from "./YtVideoWithConsent.vue?vue&type=style&index=0&id=15dec52c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15dec52c",
  null
  
)

export default component.exports